import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalNamesGA } from '../../consts';
import { MODAL_NAME } from '../injectors/injection-tokens/modal-name';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const getModalName = (): typeof ModalNamesGA[keyof typeof ModalNamesGA] => {
  const dynamicDialogConfig = inject(DynamicDialogConfig, {
    optional: true,
  });

  const injectedModalName = inject(MODAL_NAME, {
    optional: true,
  });

  const route = inject(ActivatedRoute, {
    optional: true,
  });

  return (
    route?.snapshot?.queryParams?.['modalName'] ??
    dynamicDialogConfig?.data?.modalName ??
    injectedModalName ??
    route?.snapshot.data?.['modalName']
  );
};

export const getConfirmationModalName = (): typeof ModalNamesGA[keyof typeof ModalNamesGA] => {
  const modalName = getModalName();

  return convertToConfirmationModalName(modalName);
};

const convertToConfirmationModalName = (
  modalName: typeof ModalNamesGA[keyof typeof ModalNamesGA]
): typeof ModalNamesGA[keyof typeof ModalNamesGA] => {
  return `Confirm ${modalName} Cancellation` as typeof ModalNamesGA[keyof typeof ModalNamesGA];
};
